<template>
  <div v-if="
  this.getCurrentPage !== '/proceduredetail' &&
  this.getCurrentPage !== '/maintplandetail' &&
  this.getCurrentPage !== '/workcalldetail' &&
  this.getCurrentPage !== '/workrequestdetail'
  ">
    <div v-show="false"> {{getTasksListCounter}} </div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="btnStatus.color"> {{btnStatus.icon}} </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            {{defineIDGShortLastSix(this.tasks.basic.idi)}} Procedure Step
            <v-spacer/>
            {{displayDocumentIDGTypeA(this.tasks.basic.tag, this.tasks.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout class=" ml-2 mr-2 mt-2">
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> title </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{selectedTasksItem.basic.title}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class=" ml-2 mr-2">
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> pin </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{selectedTasksItem.basic.id}}
                  </div>
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> filter_list </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{selectedTasksItem.char.status}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> yard </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{selectedTasksItem.char.theme}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> work_outline </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{selectedTasksItem.char.type}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class=" ml-2 mr-2 mt-2">
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> description </v-icon>
                  <div :class="ui.textSubheadingBold">
                      Description
                  </div>
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> build </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{selectedTasksItem.char.dis}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{selectedTasksItem.char.req}}
                </div>
              </v-layout>
              <v-layout class=" ml-2 mr-2 mt-2">
                <v-spacer/>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> category </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{selectedTasksItem.char.part}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> engineering </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{selectedTasksItem.char.resr}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> person </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{selectedTasksItem.char.per}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class=" ml-2 mr-2 mt-2">
                <v-spacer/>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> note_add </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{selectedTasksItem.char.ref}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout row class="ml-2">
                <v-flex xs6>
                  <div :class="ui.textSubheadingBold">
                    Progress Task
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row class="ml-2">
                <InfoDateAgoName :data="this.tasks.stats"/>
              </v-layout>
              <v-layout row class="ml-4 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localForm.close"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="mustBeLessThanLarge"
                  hint="tasks description"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs6 sm4 offset-sm4>
                  <v-text-field
                  :label="selectedTasksItem.char.hrsa"
                  prepend-icon="access_time_filled"
                  hint="accum. hours"
                  persistent-hint
                  suffix="hrs"
                  outline
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4>
                  <v-text-field
                  v-model="localForm.hrsa"
                  :rules="ruleNumberMoreThanZero"
                  hint="add hours"
                  prepend-icon="schedule"
                  suffix="hrs"
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> exit_to_app </v-icon>
                Close
            </v-btn>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> exit_to_app </v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn @click="validate('Issue')"
            class="hidden-xs-only"
            :color="ui.colorError" flat>
              <v-icon left> warning </v-icon>
                S
            </v-btn>
            <v-btn @click="validate('Progress')" :color="ui.colorWarning" flat>
              <v-icon left> schedule </v-icon>
                P
            </v-btn>
            <v-btn @click="validate('Done')" :color="ui.btnColor" flat>
              <v-icon left> check_box </v-icon>
                D
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import master from "@/data/forms/mixins/master.js";
import tasksOptions from "@/data/options/mixins/tasksOptions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import InfoDateAgoName from "@/frame/display/components/InfoDateAgoName";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    tasksOptions,
    techOptions,
    rulesTextfield,
    dateFunctions,
    listFunctions,
    financeFunctions,
    uisettings,
    docRevsModFunctions,
    numberFunctions,
    apptheme,
    displayFunctions,
    master
  ],
  components: {
    InfoDateAgoName
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getTasksList", "getUser", "getTasksListCounter", "getCurrentPage"]),
    reactiveResourceList() {
      return this.getTasksList;
    },
    selectedTasksItem() {
      return this.tasks;
    },
    btnStatus() {
      let obj = {
        icon: null,
        color: null
      };
      let status = this.selectedTasksItem.char.status;
      if (status === "Created") {
        obj.icon = "launch";
        obj.color = this.ui.btnColor;
      } else if (status === "Progress") {
        obj.icon = "access_time_filled";
        obj.color = this.ui.colorWarning;
      } else if (status === "Issue") {
        obj.icon = "warning";
        obj.color = this.ui.colorError;
      } else if (status === "Done") {
        obj.icon = "check_box";
        obj.color = this.ui.colorSuccess;
      } else {
        obj.icon = "launch";
        obj.color = this.ui.btnColor;
      }
      return obj;
    }
  },
  props: {
    tasks: {
      type: Object
    }
  },
  data() {
    return {
      hideActions: true,
      dialog: false,
      valid: false,
      enableSpinner: false,
      localForm: {
        title: "",
        id: "",
        dis: "",
        com: "",
        per: "",
        hrs: "",
        hrsa: "",
        ref: "",
        resr: "",
        part: "",
        status: ""
      }
    };
  },
  beforeMount() {
    this.localForm.hrs = 0;
    this.localForm.close = this.tasks.char.close;
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    refreshList() {
      let store = "changeTasksListCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getTasksListCounter + 1);
      this.$store.dispatch(store, this.getTasksListCounter - 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(5.12, 1); // parts removed.
    },
    validate(status) {
      // cosole.log(this.taskForm)
      if (this.$refs.form.validate() === true) {
        // UPDATE DATA
        let tempForm = this.tasks;
        tempForm.char.status = status;
        tempForm.char.close = this.localForm.close;
        // eslint-disable-next-line
        tempForm.char.hrsa = parseFloat(this.localForm.hrsa) + parseFloat(this.selectedTasksItem.char.hrsa);
        tempForm.char.hrsa = tempForm.char.hrsa.toString();
        tempForm.stats.date = moment().format();
        tempForm.stats.n = tempForm.stats.n + 1;
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var tempList = this.getTasksList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.changeItemReturnList(parseobj, tempList);
        this.$store.dispatch("changeTasksList", newList);
        this.refreshList();
        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
